const steps = [
    {
        id: 1,
        name: 'First step',
        active: true,
    },
    {
        id: 2,
        name: 'Second step',
        active: false,
    },
    {
        id: 3,
        name: 'Third step',
        active: false,
    },
];


export default steps;